import React from 'react';
import Page from '../components/Historia/Page';
import '../assets/css/little_wallet_new.css';


const Institucional = () => {

    return (
        <div>
            <Page />
        </div>
    );
};

export default Institucional;


/** WEBPACK FOOTER **
 ** ./src/containers/Historia.js
 **/